// import { useState } from "react"

export default function About(props) {

  let mystyle ={

    color: props.mode === 'dark'? 'white':'black',
    backgroundColor: props.mode === 'dark'? '#212529':'white',

  }



    return (
        <>
            <div className="container" style={mystyle}>
                <h2 className={`my-3 text-${props.mode === 'dark' ? 'light' : 'dark'} `}>About Us</h2>
                <div className="accordion" id="accordionExample" style={mystyle}>
                    <div className="accordion-item " >
                        <h2 className="accordion-header"  id="headingTwo">
                            <button className="accordion-button collapsed" style={mystyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                <strong>
                                    About TextHelper
                                </strong>
                            </button>
                        </h2>
                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                            <div className="accordion-body" style={mystyle}>
                                TextHelper is an easy to use online tool for counting words, characters, remove extra spaces  in real time, along with converting text from lower to upper and vice versa.
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingThree">
                            <button className="accordion-button collapsed" style={mystyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                <strong>
                                    We respect our user's privacy
                                </strong>
                            </button>
                        </h2>
                        <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                            <div className="accordion-body" style={mystyle}>

                                It’s common for other online Letter Counter Tools to keep a record of your content in their servers when you use them, but we are different.

                                We do NOT keep or view your content when you use our tool.

                                <strong>   We ensure that your content is 100% safe and only accessible by you.</strong>

                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingFour">
                            <button className="accordion-button collapsed" type="button" style={mystyle} data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                <strong>
                                 About Developer
                                </strong>
                            </button>
                        </h2>
                        <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                            <div className="accordion-body" style={mystyle}>
                                <strong>I am a Student, Web Developer And Designer currently living in Jammu And Kashmir. </strong>My Interests Range From Design To Web Development. I am also interested in Programming, Technology, And Education.

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
